export const contratos = [
    {
        "anio" : "Descargar",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "2020",
                "url" : "../../Transparencia/zip/contratos/2020.zip"
            },
            {
                "trimestre" : "2019",
                "url" : "../../Transparencia/zip/contratos/2019.zip"
            },
            {
                "trimestre" : "2018",
                "url" : "../../Transparencia/zip/contratos/2018.zip"
            },
            {
                "trimestre" : "2017",
                "url" : "../../Transparencia/zip/contratos/2017.zip"
            }
        ]
    }
]